module.exports = __webpack_public_path__ + "media/images/perks-b7739d895977b432440f37b5f5063a8b.png";